const LoginButton = ({ name, click }) => {
  return (
    <button type="button" className="login_btn" onClick={click}>
      {name}
    </button>
  );
};
export default LoginButton;
